$(document).ready(function() {
  $('.dev_blockpahination:last').addClass('dev_activePage').show();
  

  $('.dev_numbering .fa-angle-right').on('click', function(){
    var min_num =  $('.dev_activePage .dev_modifyNum input').val();
    var max_num =  $('.dev_activePage .dev_fixNum input').val();
    if(!(min_num == max_num)){
   
     $('.dev_modifyNum input').val(parseInt($(".dev_modifyNum input").val(),10) + 1);
      var active_div = $('.dev_activeWrap');
      $('.dev_activeWrap').next().next('.dev_teamWrap').addClass('dev_activeWrap');
      active_div.removeClass('dev_activeWrap');
   }
     
  });

    $('.dev_numbering .fa-angle-left').on('click', function(){
      var min_num =  $('.dev_activePage .dev_modifyNum input').val();
      if(!(min_num == 1)){
        $('.dev_modifyNum input').val(parseInt($(".dev_modifyNum input").val(),10) - 1);
        var active_div = $('.dev_activeWrap');
        $('.dev_activeWrap').prev().prev('.dev_teamWrap').addClass('dev_activeWrap');
        active_div.removeClass('dev_activeWrap');
      }
  });

   $('.dev_blogSidebar h2').on('click' , function(){
    $(this).toggleClass('dev_activeHead');
    $(this).next().slideToggle();
  });

  $('.dev_sorting input[type="checkbox"]').on('click' , function(){
    $(this).parents('li').siblings('li').find('input').prop('checked', false);
  });

  
});